"use strict";
// automatically generated by the FlatBuffers compiler, do not modify
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LogDataT = exports.LogData = void 0;
const flatbuffers = __importStar(require("flatbuffers"));
/**
 * General purpose logging datatype
 */
class LogData {
    constructor() {
        this.bb = null;
        this.bb_pos = 0;
    }
    __init(i, bb) {
        this.bb_pos = i;
        this.bb = bb;
        return this;
    }
    static getRootAsLogData(bb, obj) {
        return (obj || new LogData()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    static getSizePrefixedRootAsLogData(bb, obj) {
        bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
        return (obj || new LogData()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    message(optionalEncoding) {
        const offset = this.bb.__offset(this.bb_pos, 4);
        return offset ? this.bb.__string(this.bb_pos + offset, optionalEncoding) : null;
    }
    data(index) {
        const offset = this.bb.__offset(this.bb_pos, 6);
        return offset ? this.bb.readUint8(this.bb.__vector(this.bb_pos + offset) + index) : 0;
    }
    dataLength() {
        const offset = this.bb.__offset(this.bb_pos, 6);
        return offset ? this.bb.__vector_len(this.bb_pos + offset) : 0;
    }
    dataArray() {
        const offset = this.bb.__offset(this.bb_pos, 6);
        return offset ? new Uint8Array(this.bb.bytes().buffer, this.bb.bytes().byteOffset + this.bb.__vector(this.bb_pos + offset), this.bb.__vector_len(this.bb_pos + offset)) : null;
    }
    static startLogData(builder) {
        builder.startObject(2);
    }
    static addMessage(builder, messageOffset) {
        builder.addFieldOffset(0, messageOffset, 0);
    }
    static addData(builder, dataOffset) {
        builder.addFieldOffset(1, dataOffset, 0);
    }
    static createDataVector(builder, data) {
        builder.startVector(1, data.length, 1);
        for (let i = data.length - 1; i >= 0; i--) {
            builder.addInt8(data[i]);
        }
        return builder.endVector();
    }
    static startDataVector(builder, numElems) {
        builder.startVector(1, numElems, 1);
    }
    static endLogData(builder) {
        const offset = builder.endObject();
        return offset;
    }
    static createLogData(builder, messageOffset, dataOffset) {
        LogData.startLogData(builder);
        LogData.addMessage(builder, messageOffset);
        LogData.addData(builder, dataOffset);
        return LogData.endLogData(builder);
    }
    unpack() {
        return new LogDataT(this.message(), this.bb.createScalarList(this.data.bind(this), this.dataLength()));
    }
    unpackTo(_o) {
        _o.message = this.message();
        _o.data = this.bb.createScalarList(this.data.bind(this), this.dataLength());
    }
}
exports.LogData = LogData;
class LogDataT {
    constructor(message = null, data = []) {
        this.message = message;
        this.data = data;
    }
    pack(builder) {
        const message = (this.message !== null ? builder.createString(this.message) : 0);
        const data = LogData.createDataVector(builder, this.data);
        return LogData.createLogData(builder, message, data);
    }
}
exports.LogDataT = LogDataT;
